'use client'

import { init } from './init'

init()
export const ClientInit = () => null
